import {
  Avatar,
  Box,
  Typography,
  Paper,
  IconButton,
  Collapse,
  Modal,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Api from "../../api/Api.js";
import SendIcon from "@mui/icons-material/Send";
import ForumIcon from "@mui/icons-material/Forum";
import { Urls } from "../../api/Urls.js";
import { toast } from "react-toastify";
import { colors } from "../../theme/colors.js";
import moment from "moment";
import "./Style.scss";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Add,
  Close,
  Delete,
  MessageOutlined,
  Report,
} from "@mui/icons-material";
import Pagination from "../../components/pagination/Pagination.js";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { useTranslation } from "react-i18next";
import { showDate } from "../../utils/utils.js";
import { useAuthContext } from "../../hooks/useAuthContext.js";

function Messages() {
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const [loadingMessages, setLoadingMessages] = useState(true);
  const [loadingChats, setLoadingChats] = useState(true);
  const location = useLocation();
  const [openChats, setOpenChats] = useState(true);
  const chat = location?.state?.data;
  const [pageConv, setPageConv] = useState(1);
  const [selectedConvDetails, setSelectedConvDetails] = useState({});
  const [conversations, setConversations] = useState([]);

  const [messages, setMessages] = useState([]);
  const containerRef = useRef(null);
  const [dataConv, setDataConv] = useState(null);

  const { t } = useTranslation();

  // State for delete modal and message
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState(null);

  // Delete handler
  const handleDeleteMessage = (msg) => {
    setMessageToDelete(msg);
    setOpenDeleteModal(true);
  };

  // Confirm delete
  const confirmDeleteMessage = () => {
    if (!messageToDelete) return;
    Api.delete(
      `/admin/shipping/${selectedConversation}/messages/${messageToDelete.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${access_token}`,
          "accept-language": localStorage.getItem("i18nextLng"),
        },
      }
    )
      .then(() => {
        setMessages((prev) => prev.filter((m) => m.id !== messageToDelete.id));
        setOpenDeleteModal(false);
        setMessageToDelete(null);
        toast.success(t("messages.delete_success"));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || t("messages.delete_error"));
        setOpenDeleteModal(false);
        setMessageToDelete(null);
      });
  };

  const ChatMessage = ({ message }) => {
    return (
      <Box
        display="flex"
        justifyContent={"flex-start"}
        alignItems={"start"}
        gap="10px"
        mb={2}
      >
        <Box>
          <Avatar
            src={message?.user?.file_url}
            alt={""}
            sx={{ mr: 1, alignSelf: "flex-start" }}
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <Typography sx={{ maxWidth: "120px", fontSize: "16px" }}>
            {message?.user?.first_name + " " + message?.user?.last_name}
          </Typography>
          <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
            <Paper
              elevation={3}
              sx={{
                padding: "5px 10px",
                maxWidth: {
                  xs: "120px",
                  sm: "120px",
                  md: "400px",
                  lg: "500px",
                },
                borderRadius: "6px",
                backgroundColor: "#1976D2",
                color: "#fff",
                position: "relative",
              }}
            >
              <Typography sx={{ textAlign: "left" }}></Typography>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "18px",
                  display: "block",
                  textAlign: "left",
                }}
              >
                {message?.message}
              </Typography>
            </Paper>
            <IconButton
              size="small"
              sx={{ color: "red" }}
              onClick={() => handleDeleteMessage(message)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        <Box>
          <Typography sx={{ fontWeight: "600", fontSize: "16px" }}>
            {moment(message?.created_at).format("HH:mm")}
          </Typography>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    setLoadingChats(true);
    Api.get("/admin/chats", {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${access_token}`,
        "accept-language": localStorage.getItem("i18nextLng"),
      },
      params: { pageSize: pageSize, page: pageConv },
    })
      .then((res) => {
        if (chat && pageConv == 1) {
          if (chat?.last_message !== null) {
            let chat_filter = res?.data?.data?.filter(
              (c) => c.shipping_id === chat?.shipping_id
            )[0];
            if (chat_filter) {
              setSelectedConversation(chat_filter.shipping_id);
              setSelectedConvDetails(chat_filter);
              setConversations(res?.data?.data);
            } else {
              setConversations(res?.data?.data?.concat([chat]));
              setSelectedConversation(chat.shipping_id);
              setSelectedConvDetails(chat);
            }
          } else {
            setConversations(res?.data?.data?.concat([chat]));
            setSelectedConversation(chat.shipping_id);
            setSelectedConvDetails(chat);
          }
        } else {
          if (selectedConversation !== null) {
            setSelectedConversation(selectedConversation);
            setSelectedConvDetails(
              res?.data?.data.filter(
                (chat) => selectedConversation === chat.shipping_id
              )[0]
            );
            setConversations(res?.data?.data);
          } else {
            setConversations(res?.data?.data);
          }
        }
        setDataConv(res?.data);
        setLoadingChats(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoadingChats(false);
      });
  }, [pageConv]);
  useEffect(() => {
    if (selectedConversation !== null) {
      if (page === 1) {
        setLoadingMessages(true);
      }
      Api.get(`/shipping/${selectedConversation}/messages`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${access_token}`,
          "accept-language": localStorage.getItem("i18nextLng"),
        },
        params: {
          pageSize: pageSize,
          before:
            page === 1
              ? new Date()
              : messages[messages?.length - 1]?.created_at,
        },
      })
        .then((res) => {
          if (page === 1) {
            setMessages(() => res?.data?.data);
          } else {
            setMessages((messages) => messages?.concat(res?.data?.data));
          }
          setData(res?.data);
          setLoadingMessages(false);
        })
        .catch((err) => {
          setLoadingMessages(false);
          toast.error(err?.response?.data?.message);
        });
    }
  }, [selectedConversation, page]);

  const groupMessagesByDate = (messages) => {
    return messages.reduce((groups, message) => {
      const messageDate = moment(message.created_at).format("YYYY-MM-DD");
      if (!groups[messageDate]) {
        groups[messageDate] = [];
      }
      groups[messageDate].unshift(message);
      return groups;
    }, {});
  };

  const renderMessagesWithDateHeaders = () => {
    const groupedMessages = groupMessagesByDate(messages);

    return Object.entries(groupedMessages).map(([date, msgs]) => (
      <Box key={date}>
        <Box sx={{ textAlign: "center", margin: "10px 0", color: "gray" }}>
          {showDate(date)}
        </Box>
        {msgs?.map((message, index) => {
          return <ChatMessage key={index} message={message} />;
        })}
      </Box>
    ));
  };

  return (
    <Box
      minHeight={"100vh"}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          fontSize: {
            xs: "26px",
            sm: "26px",
            md: "42px",
            lg: "42px",
          },
          fontWeight: "800",
          color: "#6F6B7D",
        }}
      >
        {t("pages.message.messages")}
      </Typography>
      <Box sx={{ display: "flex", gap: "15px" }} className={"container"}>
        <Box
          sx={{
            flex: 1.3,
            display: "flex",
            maxWidth: "100vw",
            boxSizing: "border-box",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              gap: "0px",
              overflowY: "auto",
            }}
            className={"chats-container"}
          >
            {conversations?.length === 0 && !loadingChats && (
              <Box
                sx={{
                  height: "70vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box sx={{ width: "200px", height: "200px" }}>
                  <Box
                    sx={{
                      height: "200px",
                      width: "200px",
                      borderRadius: "50%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ForumIcon sx={{ color: colors?.primary, fontSize: 80 }} />
                    <Typography
                      sx={{
                        textAlign: "center",
                        maxWidth: "150px",
                        color: "gray",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      {t("pages.message.no_conv")}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
            {conversations?.length > 0 && (
              <Box>
                {conversations?.map((discussion, index) => (
                  <Box
                    key={index}
                    onClick={() => {
                      setSelectedConversation(discussion?.shipping_id);
                      setSelectedConvDetails(discussion);
                      setPage(1);
                    }}
                    sx={{
                      display: "flex",
                      gap: "5px",
                      backgroundColor:
                        selectedConversation === discussion.shipping_id
                          ? "rgba(3, 138, 255,0.2)"
                          : "white",
                      padding: "10px",
                      borderTop: "1px solid lightgray",

                      cursor: "pointer",
                      ":hover": {
                        filter: "brightness(0.95)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: "110px",
                        display: "flex",
                        justifyContent: "space-between",
                        position: "relative",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <Box sx={{ position: "relative" }}>
                          <Avatar
                            sx={{
                              border: "4px solid " + colors.primary,
                              height: "55px",
                              width: "55px",
                            }}
                            src={discussion.participants[0]?.file_url}
                            variant={"circular"}
                          />
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          position: "absolute",
                          top: 0,

                          left: 40,
                        }}
                      >
                        <Box sx={{ position: "relative" }}>
                          <Avatar
                            sx={{
                              border: "4px solid " + colors.primary,
                              height: "55px",
                              width: "55px",
                            }}
                            src={discussion.participants[1]?.file_url}
                            variant={"circular"}
                          />
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          textOverflow: "ellipsis",
                          wordBreak: "break-word",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {discussion?.package_title} -{" "}
                      </Typography>
                      <Typography
                        sx={{
                          textOverflow: "ellipsis",
                          wordBreak: "break-word",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {discussion?.departure?.name_en}{" "}
                        {t("pages.my_trips.to")}{" "}
                        {discussion?.destination?.name_en}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
          {/* chats container for mobile devices */}
          <Box className={"chevron-container"}>
            {openChats && (
              <IconButton
                onClick={() => {
                  setOpenChats(false);
                }}
              >
                <FontAwesomeIcon icon={faChevronUp} size={"1x"} />
              </IconButton>
            )}

            {!openChats && (
              <IconButton
                onClick={() => {
                  setOpenChats(true);
                }}
              >
                <FontAwesomeIcon icon={faChevronDown} size={"1x"} />
              </IconButton>
            )}
          </Box>
          <Collapse in={openChats} timeout={200} unmountOnExit>
            <Box
              sx={{
                gap: "0px",
                overflowX: "auto",
              }}
              className={"chats-container-mobile"}
            >
              {conversations?.length === 0 && !loadingChats && (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ width: "200px", height: "200px" }}>
                    <Box
                      sx={{
                        height: "200px",
                        width: "200px",
                        borderRadius: "50%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <ForumIcon
                        sx={{ color: colors?.primary, fontSize: 80 }}
                      />
                      <Typography
                        sx={{
                          textAlign: "center",
                          maxWidth: "150px",
                          color: "gray",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {t("pages.message.no_conv")}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
              {conversations?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    boxSizing: "border-box",
                  }}
                >
                  {conversations?.map((discussion, index) => (
                    <Box
                      key={index}
                      onClick={() => {
                        setSelectedConversation(discussion?.shipping_id);
                        setSelectedConvDetails(discussion);
                        setPage(1);
                        setOpenChats(false);
                      }}
                      sx={{
                        display: "flex",
                        gap: "5px",
                        backgroundColor:
                          selectedConversation === discussion.shipping_id
                            ? "rgba(3, 138, 255,0.2)"
                            : "white",
                        padding: "10px",
                        flexDirection: "column",
                        cursor: "pointer",
                        ":hover": {
                          filter: "brightness(0.95)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          minWidth: "110px",
                          display: "flex",
                          position: "relative",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                          }}
                        >
                          <Box sx={{ position: "relative" }}>
                            <Avatar
                              sx={{
                                border: "4px solid " + colors.primary,
                                height: "55px",
                                width: "55px",
                              }}
                              src={discussion.participants[0]?.file_url}
                              variant={"circular"}
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            position: "absolute",
                            top: 0,
                            left: 40,
                          }}
                        >
                          <Box sx={{ position: "relative" }}>
                            <Avatar
                              sx={{
                                border: "4px solid " + colors.primary,
                                height: "55px",
                                width: "55px",
                              }}
                              src={discussion.participants[1]?.file_url}
                              variant={"circular"}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            wordBreak: "break-word",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                        >
                          {discussion?.package_title} -{" "}
                        </Typography>
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            wordBreak: "break-word",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                        >
                          {discussion?.departure?.name_en}{" "}
                          {t("pages.my_trips.to")}{" "}
                          {discussion?.destination?.name_en}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            <Box className={"pagination-container-mobile"}>
              <Pagination
                setPage={setPageConv}
                currentPage={pageConv}
                itemsPerPage={pageSize}
                totalItems={dataConv?.pagination?.total}
              />
            </Box>
          </Collapse>
          <Box className={"pagination-container"}>
            <Pagination
              setPage={setPageConv}
              currentPage={pageConv}
              itemsPerPage={pageSize}
              totalItems={dataConv?.pagination?.total}
            />
          </Box>
        </Box>

        <Box
          sx={{
            flex: 3,
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <Box>
            {selectedConvDetails?.package_title && (
              <Paper
                elevation={3}
                sx={{
                  padding: "10px 15px",
                  backgroundColor: "#f5f5f5",
                  color: "#000",
                  boxSizing: "border-box",
                  display: "flex",
                  gap: "16px",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    {selectedConvDetails?.package_title} -{" "}
                  </Typography>
                  <Typography
                    sx={{
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    {selectedConvDetails?.departure?.name_en}{" "}
                    {t("pages.my_trips.to")}{" "}
                    {selectedConvDetails?.destination?.name_en}
                  </Typography>
                </Box>
              </Paper>
            )}
          </Box>
          <Box
            width={"100%"}
            display="flex"
            flexDirection="column"
            height="65vh"
          >
            <>
              <Box
                ref={containerRef}
                sx={{
                  display: "flex",
                  flexDirection: "column-reverse",
                  flex: 1,
                  overflow: "auto",
                  height: "70vh",
                  backgroundColor: "rgba(3, 138, 255,0.1)",
                  borderRadius: "10px",
                  p: 3,
                }}
              >
                {loadingMessages && selectedConversation && (
                  <Box>
                    <CircularProgress />
                  </Box>
                )}
                {!selectedConversation && (
                  <Box
                    sx={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ width: "200px", height: "200px" }}>
                      <Box
                        sx={{
                          height: "200px",
                          width: "200px",
                          borderRadius: "50%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <MessageOutlined sx={{ color: "gray", fontSize: 80 }} />
                        <Typography
                          sx={{
                            textAlign: "center",
                            maxWidth: "150px",
                            color: "gray",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                        >
                          {t("pages.message.no_conv_sel")}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                )}
                {!loadingMessages && selectedConversation && (
                  <Box display="flex" flexDirection="column-reverse">
                    {messages?.length > 0 ? (
                      renderMessagesWithDateHeaders()
                    ) : (
                      <Box
                        sx={{
                          height: "400px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "200px", height: "200px" }}>
                          <Box
                            sx={{
                              height: "200px",
                              width: "200px",
                              borderRadius: "50%",
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <MessageOutlined
                              sx={{ color: "gray", fontSize: 80 }}
                            />
                            <Typography
                              sx={{
                                textAlign: "center",
                                maxWidth: "150px",
                                color: "gray",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              {t("pages.message.no_message")}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {data?.pagination?.total / pageSize > page && (
                      <Box>
                        <IconButton
                          onClick={() => {
                            console.log(data?.pagination?.total / pageSize);
                            if (data?.pagination?.total / pageSize > page) {
                              setPage(page + 1);
                            }
                          }}
                        >
                          <Add />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </>
            {selectedConversation &&
              selectedConvDetails?.shipping_status === "delivered" && (
                <Box>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: "10px 15px",
                      backgroundColor: colors?.primary,
                      color: "white",
                      boxSizing: "border-box",
                      display: "flex",
                      gap: "16px",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          textOverflow: "ellipsis",
                          wordBreak: "break-word",
                          textAlign: "center",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {t("pages.message.closed")}
                      </Typography>
                    </Box>
                  </Paper>
                </Box>
              )}
          </Box>
        </Box>
      </Box>
      <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            minWidth: 300,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            {t("messages.delete_confirm_title")}
          </Typography>
          <Typography sx={{ mb: 3 }}>
            {t("messages.delete_confirm_text")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              alignItems: "center",
            }}
          >
            <IconButton onClick={() => setOpenDeleteModal(false)}>
              <Close />
            </IconButton>
            <IconButton color="error" onClick={confirmDeleteMessage}>
              <Delete />
            </IconButton>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
export default Messages;
